var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "preview-sp",
    [
      _vm.isFinishCreated
        ? [
            _c("job-preview-detail-sp", {
              staticClass: "sp-print-area",
              attrs: { offer: _vm.offer },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "margin-1 pega-hide-msg" }, [
              _vm._v(
                "\n      これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。あらかじめご了承ください。\n    "
              ),
            ]),
            _vm._v(" "),
            _c("job-category-setting-sp", {
              attrs: { "job-category-settings": _vm.offer.jobCategorySettings },
            }),
            _vm._v(" "),
            _vm.matching
              ? _c("job-matching-setting-sp", {
                  attrs: { matching: _vm.matching },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }